const ONE_DAY_SECONDS = 86400

/** 根据绑定截止时间戳（13 位 ms）计算剩余秒数 */
export function remainSec(deadTime, now = Date.now()) {
  if (!deadTime) return 0
  return Math.max(0, Math.floor((deadTime - now) / 1000))
}

/** 格式化倒计时文案：≥24h 为 `X d Y h`，<24h 为 `HH:MM:SS` */
export function fmtText(seconds) {
  if (seconds <= 0) return '0 d 0 h'

  if (seconds >= ONE_DAY_SECONDS) {
    const days = Math.floor(seconds / ONE_DAY_SECONDS)
    const hours = Math.floor((seconds % ONE_DAY_SECONDS) / 3600)
    return `${days} d ${hours} h`
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60
  const pad = (n) => String(n).padStart(2, '0')
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`
}

/** 是否进入紧急倒计时（剩余不足 24 小时） */
export function isUrgent(seconds) {
  return seconds > 0 && seconds < ONE_DAY_SECONDS
}

/** 是否已绑定上级代理（upperAgent 有 presentId 或 uid） */
export function hasUpper(upperAgent) {
  if (!upperAgent) return false
  return !!(upperAgent.presentId || upperAgent.uid)
}

/** 将 contact/main 的 upperAgent 映射为页面卡片字段 */
export function mapUpper(upperAgent) {
  if (!hasUpper(upperAgent)) return null

  return {
    avatar: upperAgent.avatar || '',
    nickname: upperAgent.nickname || '',
    presentId: upperAgent.presentId || '',
    locationFlagRound: upperAgent.locationFlagRound || '',
    uid: upperAgent.uid || 0,
    hasContact: !!upperAgent.hasContact,
    canSendContact: !!upperAgent.canSendContact,
    gender: upperAgent.gender,
    type: '2',
  }
}
